<template>
  <v-card class="elevation-6 preview-card professional-ui" style="width: 100%">
    <overlay-loading-progress :LoadingFlag="LoadingFlag" />
    <v-app-bar color="primary" dense dark elevate-on-scroll flat>
      <v-toolbar-title class="text-h5 font-weight-bold">
        <v-icon left class="mr-2">mdi-school</v-icon>
        Student Scholarship Preview
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closePrompt">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-app-bar>
    <v-card-text class="pt-6 pb-6 px-8">
      <v-row>
        <v-col cols="12" v-if="records.DescriptionTxt != ''">
          <v-alert type="info" border="left" colored-border elevation="2" class="mb-6">
            <div class="d-flex align-center">
              <v-icon color="primary" class="mr-2">mdi-information</v-icon>
              <span class="font-weight-bold text-h6">Description</span>
            </div>
            <div class="mt-2" v-html="records.DescriptionTxt"></div>
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4" class="d-flex flex-column align-center justify-center">
          <v-avatar size="160" class="elevation-2 mb-4">
            <v-img :src="records.StudentImagePath" contain></v-img>
          </v-avatar>
          <div class="caption grey--text">Student Photo</div>
        </v-col>
        <v-col cols="12" md="8">
          <v-card class="pa-5 mb-6 section-card">
            <div class="section-header-gradient d-flex align-center mb-4 px-5 py-3 rounded-lg">
              <v-icon color="white" size="30" class="mr-3">mdi-account-details</v-icon>
              <span class="section-title pro-section-title white--text">Student Details</span>
            </div>
            <v-row class="text-h6">
              <v-col cols="6"><b>Application Number:</b> {{ records.ApplicationNumber }}</v-col>
              <v-col cols="6"><b>Name:</b> {{ records.StudentName }}</v-col>
              <v-col cols="6"><b>Gender:</b> {{ records.Gender }}</v-col>
              <v-col cols="6"><b>School:</b> {{ records.StudentSchoolName }}</v-col>
              <v-col cols="6"><b>Parent Name:</b> {{ records.StudentParentName }}</v-col>
              <v-col cols="6"><b>Parent Contact:</b> {{ records.ParentContact }}</v-col>
              <v-col cols="6"><b>Category:</b> {{ records.Category }}</v-col>
              <v-col cols="6"><b>Sponsor Name:</b> {{ records.SponserName }}</v-col>
              <v-col cols="6">
                <b>Scholarship Type:</b>
                <v-chip :color="records.StudentScholarshipTypeColor" class="white--text font-weight-bold">
                  {{ records.StudentScholarshipTypeTxt }}
                </v-chip>
              </v-col>
              <v-col cols="6">
                <b>Approval Status:</b>
                <v-chip :color="records.StudentApprovalStatusColor" class="white--text font-weight-bold">
                  {{ records.StudentApprovalStatusTxt }}
                </v-chip>
              </v-col>
              <v-col cols="6">
                <b>Application Status:</b>
                <v-chip :color="records.ReportStatusColor" class="white--text font-weight-bold">
                  {{ records.ReportStatusTxt }}
                </v-chip>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-card class="pa-5 mb-6 section-card">
            <div class="section-header-gradient d-flex align-center mb-4 px-5 py-3 rounded-lg">
              <v-icon color="white" size="30" class="mr-3">mdi-bank</v-icon>
              <span class="section-title pro-section-title white--text">Bank Details</span>
            </div>
            <v-row class="text-h6">
              <v-col cols="6"><b>Account Holder:</b> {{ records.AccountHolderName }}</v-col>
              <v-col cols="6"><b>Account Number:</b> {{ records.AccountNumber }}</v-col>
              <v-col cols="6"><b>Bank Name:</b> {{ records.BankName }}</v-col>
              <v-col cols="6"><b>Branch Name:</b> {{ records.BranchName }}</v-col>
              <v-col cols="6"><b>IFSC Code:</b> {{ records.IfscCode }}</v-col>
              <v-col cols="6">
                <b>Account Status:</b>
                <v-chip :color="records.AccountStatusTxtColor" class="white--text font-weight-bold">
                  {{ records.AccountStatusTxt }}
                </v-chip>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card class="pa-5 mb-6 section-card">
            <div class="section-header-gradient d-flex align-center mb-4 px-5 py-3 rounded-lg">
              <v-icon color="white" size="30" class="mr-3">mdi-book-open-variant</v-icon>
              <span class="section-title pro-section-title white--text">Mark Details</span>
            </div>
            <v-row class="text-h6">
              <v-col cols="12"><b>Class:</b> {{ records.ClassName }} th std</v-col>
              <v-col cols="12"><b>Percentage:</b> {{ records.Percentage }}%</v-col>
              <v-col cols="12"><b>Student Type:</b> {{ records.StudentType }}</v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card class="pa-5 mb-6 section-card">
            <div class="section-header-gradient d-flex align-center mb-4 px-5 py-3 rounded-lg">
              <v-icon color="white" size="30" class="mr-3">mdi-cash-multiple</v-icon>
              <span class="section-title pro-section-title white--text">Transaction Details</span>
            </div>
            <v-simple-table class="text-h6">
              <thead>
                <tr>
                  <th class="text-subtitle-1 font-weight-bold">Transaction Type</th>
                  <th class="text-subtitle-1 font-weight-bold">Issued Date</th>
                  <th class="text-subtitle-1 font-weight-bold">Issued Amount</th>
                  <th class="text-subtitle-1 font-weight-bold">Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in records.ScholarshipIssued" :key="index">
                  <td class="text-subtitle-1">{{ item.TransactionTypeName }}</td>
                  <td class="text-subtitle-1">{{ item.ScholarshipIssuedDate }}</td>
                  <td class="text-subtitle-1">{{ item.ScholarshipIssuedAmount }} Rs</td>
                  <td class="text-subtitle-1">{{ item.ScholarshipIssuedRemarks }}</td>
                </tr>
                <tr v-if="records.ScholarshipIssued.length === 0">
                  <td colspan="4" class="text-center">-- NA --</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card class="pa-5 section-card">
            <div class="section-header-gradient d-flex align-center mb-4 px-5 py-3 rounded-lg">
              <v-icon color="white" size="30" class="mr-3">mdi-paperclip</v-icon>
              <span class="section-title pro-section-title white--text">Attachments</span>
            </div>
            <div v-viewer class="text-center">
              <v-row>
                <v-col cols="6" md="3" class="text-center mb-4">
                  <b>Recommendation Letter</b><br />
                  <v-img :src="records.RecommendationLetterImagePath" height="150" class="image-border mt-2" contain></v-img>
                  <div class="text-center mt-2">
                    <a :href="records.RecommendationLetterImagePath" :download="records.RecommendationLetterImagePath" target="_blank" class="download-link">
                      <v-icon color="primary">mdi-download</v-icon>
                    </a>
                  </div>
                </v-col>
                <v-col cols="6" md="3" class="text-center mb-4">
                  <b>Income Proof</b><br />
                  <v-img :src="records.IncomeProofImagePath" height="150" class="image-border mt-2" contain></v-img>
                  <div class="text-center mt-2">
                    <a :href="records.IncomeProofImagePath" :download="records.IncomeProofImagePath" target="_blank" class="download-link">
                      <v-icon color="primary">mdi-download</v-icon>
                    </a>
                  </div>
                </v-col>
                <v-col cols="6" md="3" class="text-center mb-4">
                  <b>Passbook</b><br />
                  <v-img :src="records.PassbookImagePath" height="150" class="image-border mt-2" contain></v-img>
                  <div class="text-center mt-2">
                    <a :href="records.PassbookImagePath" :download="records.PassbookImagePath" target="_blank" class="download-link">
                      <v-icon color="primary">mdi-download</v-icon>
                    </a>
                  </div>
                </v-col>
                <v-col cols="6" md="3" class="text-center mb-4">
                  <b>Marksheet</b><br />
                  <v-img :src="records.MarksheetImagePath" height="150" class="image-border mt-2" contain></v-img>
                  <div class="text-center mt-2">
                    <a :href="records.MarksheetImagePath" :download="records.MarksheetImagePath" target="_blank" class="download-link">
                      <v-icon color="primary">mdi-download</v-icon>
                    </a>
                  </div>
                </v-col>
                <v-col cols="6" md="3" class="text-center mb-4" v-if="records.SpecialCategoryDocumentImagePath && records.SpecialCategoryDocumentImagePath != 'NA'">
                  <b>Special Category Document</b><br />
                  <v-img :src="records.SpecialCategoryDocumentImagePath" height="150" class="image-border mt-2" contain></v-img>
                  <div class="text-center mt-2">
                    <a :href="records.SpecialCategoryDocumentImagePath" :download="records.SpecialCategoryDocumentImagePath" target="_blank" class="download-link">
                      <v-icon color="primary">mdi-download</v-icon>
                    </a>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  components: {},
  props: {
    pageTitle: {
      type: String,
    },
    recordData: {
      required: true,
    },
  },
  data() {
    return {
      valid1: false,
      valid2: false,
      ProgressLoadingFlag: false,
      submitFlag: false,
      LoadingFlag: false,

      records: [],
      Description: "",
      DescriptionRules: [(v) => !!v || "Description is required"],

      ScholarshipLoadingFlag: false,
      RejectLoadingFlag: false,
      EmpowerHerLoadingFlag: false,

      ProgessStart: 0,

      LoadingFlag: false,
      OverlayLoadingFlag: false,

      SuccessMessageTxtFlag: 0,
      SuccessMessageTxt: "",

      ErrorMessageTxtFlag: 0,
      ErrorMessageTxt: "",

      CardContent: [],
      PageInfo: {},
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      this.pageData();
    },
  },
  methods: {
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hidePreviewRecordPrompt");
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      this.pageData();
    },
    pageData() {
      console.log("pageData called");
      this.getStudentDetails();
    },
    getStudentDetails() {
      console.log(" getStudentDetails is called");

      var StudentId = this.recordData.StudentId;
      StudentId = StudentId == (null || undefined) ? "" : StudentId;
      console.log("StudentId=" + StudentId);

      if (StudentId > 0) {
        var upload = {
          UserInterface: 2,
          Student: StudentId,
        };
        console.log({ upload });

        this.LoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/student/show";
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.records = records;
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "";
        if (StudentId == "") {
          message += "Student scholarship should not be empty.";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
  <style scoped>
.section-header-gradient {
  background: linear-gradient(90deg, #1976d2 0%, #42a5f5 100%);
  color: #fff !important;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(25, 118, 210, 0.08);
}
/* #scrollable-container {
  padding: 16px;
  max-height: 80vh;
  overflow-y: auto;
} */
.professional-ui {
  background: #f8fafc;
  border-radius: 18px;
}
.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(60,60,60,0.07);
}
.v-card-text {
  padding: 32px 32px 24px 32px;
}
.section-title {
  color: #1a237e;
  letter-spacing: 0.5px;
}
.image-border {
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  margin-top: 10px;
  background: #f5f5f5;
}
.text-center {
  text-align: center;
}
.caption {
  font-size: 0.95rem;
  color: #757575;
}
</style>
.pro-section-title {
  font-size: 1.45rem;
  font-weight: 700;
  letter-spacing: 0.5px;
}
.pro-chip {
  font-size: 1rem;
  min-width: 120px;
  justify-content: center;
  border-radius: 18px;
  box-shadow: 0 1px 4px rgba(60,60,60,0.08);
  padding: 0 12px;
}
.download-link {
  transition: filter 0.2s, transform 0.2s;
  display: inline-block;
}
.download-link:hover {
  filter: brightness(1.2) drop-shadow(0 2px 8px #1976d2aa);
  transform: scale(1.12);
}